import React, { useEffect, useState } from 'react';
import {
  FaBuilding,
  FaIndustry,
  FaMapMarkerAlt,
  FaUsers,
  FaBullseye,
  FaArrowRight,
  FaArrowLeft,
  FaRocket,
  FaCopy,
  FaDownload,
  FaCheckCircle
} from 'react-icons/fa';

function AnalysisForm() {

  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');

    if (!token || !user) {
      // User is not logged in - redirect to login page
      window.location.href = '/login';
    }
  }, []);

  const text = "Risk Assessment for dfvs Risk 1: Dependence on Limited Target Market • Risk Description: dfvs currently targets a specific market (jhgdggjbn), which may be limited in size or growth potential. • Potential Impact: Revenue stagnation or decline if the target market does not grow or shrinks. • Mitigation Strategies: + Diversify target markets to reduce dependence on a single market. + Conduct market research to identify new opportunities and expand the target market. + Develop a market diversification plan to achieve a balanced revenue stream. Risk 2: Limited Revenue Streams • Risk Description: dfvs has an annual revenue of ₹1M - ₹5M, which may not be sufficient to sustain business growth. • Potential Impact: Insufficient funds to invest in growth initiatives, talent acquisition, or unexpected expenses. • Mitigation Strategies: + Explore new services or products to offer existing customers, increasing average revenue per user (ARPU). + Develop strategic partnerships to access new revenue streams. + Implement a pricing strategy review to ensure competitiveness. Risk 3: High Employee Turnover • Risk Description: With a team size of 5-10 employees, dfvs may be vulnerable to employee turnover, which can impact business continuity. • Potential Impact: Loss of key skills, knowledge, and relationships, leading to decreased productivity and revenue. • Mitigation Strategies: + Develop an employee retention plan, including competitive salaries, benefits, and growth opportunities. + Implement a knowledge management system to document key processes and reduce dependence on individual employees. + Foster a positive company culture to enhance employee engagement. Risk 4: Over-reliance on PPC Advertising • Risk Description: dfvs relies heavily on PPC Advertising, which may not be a sustainable or cost-effective marketing strategy. • Potential Impact: Decreased marketing ROI, reduced website traffic, and lower conversion rates. • Mitigation Strategies: + Diversify marketing channels to include organic search, social media, content marketing, and email marketing. + Conduct a marketing channel review to optimize PPC Advertising campaigns and improve ROI. + Develop a content marketing strategy to reduce dependence on paid advertising. Risk 5: Inadequate Customer Feedback Mechanisms • Risk Description: dfvs conducts quarterly customer reviews, which may not be sufficient to identify and address customer concerns. • Potential Impact: Decreased customer satisfaction, negative word-of-mouth, and lost business opportunities. • Mitigation Strategies: + Implement a more frequent customer feedback mechanism, such as regular surveys or Net Promoter Score (NPS) tracking. + Develop a customer feedback response plan to ensure timely and effective resolution of customer concerns. + Use customer feedback to inform product or service development and improve overall customer experience. Risk 6: Unclear Growth Goals • Risk Description: dfvs has growth goals (sgdfhg), but they may not be specific, measurable, achievable, relevant, or time-bound (SMART). • Potential Impact: Lack of direction, inefficient resource allocation, and decreased motivation. • Mitigation Strategies: + Develop SMART growth goals, aligned with the company's mission and vision. + Establish key performance indicators (KPIs) to track progress toward growth goals. + Regularly review and adjust growth goals to ensure they remain relevant and achievable. Risk 7: Current Challenges (sfadgfd) • Risk Description: dfvs faces current challenges (sfadgfd), which may impact business operations and growth. • Potential Impact: Decreased productivity, revenue, or customer satisfaction. • Mitigation Strategies: + Identify and prioritize current challenges. + Develop a plan to address each challenge, including resource allocation and timelines. + Regularly review progress and adjust the plan as needed.";

  const formatRiskContent = (text) => {
    // Split by "Risk X:" pattern
    const risks = text.split(/(?=Risk \d+:)/g);

    // Extract company name from first part
    const firstPart = risks.shift(); // "Risk Assessment for dfvs "
    const companyName = firstPart.replace("Risk Assessment for ", "").trim();

    const formattedRisks = risks.map(risk => {
      // Extract risk number and title
      const titleMatch = risk.match(/Risk (\d+): (.+?)(?= •|$)/);
      const riskNumber = titleMatch ? titleMatch[1] : "";
      const riskTitle = titleMatch ? titleMatch[2] : "";

      // Extract description
      const descMatch = risk.match(/• Risk Description: (.+?)(?= • Potential Impact:|$)/s);
      const description = descMatch ? descMatch[1].trim() : "";

      // Extract impact
      const impactMatch = risk.match(/• Potential Impact: (.+?)(?= • Mitigation Strategies:|$)/s);
      const impact = impactMatch ? impactMatch[1].trim() : "";

      // Extract strategies
      const strategiesMatch = risk.match(/• Mitigation Strategies: (.+?)(?=Risk \d+:|$)/s);
      let strategies = [];
      if (strategiesMatch) {
        const strategiesText = strategiesMatch[1];
        // Split by "+" and clean up
        strategies = strategiesText.split(/\+/).map(str => str.trim()).filter(str => str.length > 0);
      }

      return {
        number: parseInt(riskNumber),
        title: riskTitle,
        description: description,
        impact: impact,
        strategies: strategies
      };
    });

    return {
      company: companyName,
      risks: formattedRisks
    };
  };

  const renderFormattedContent = () => {
    const data = formatRiskContent(text);

    const styles = `
    .risk-container {
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      max-width: 1000px;
      margin: 0 auto;
      padding: 20px;
      background: #f8f9fa;
    }
    
    .risk-header {
      text-align: center;
      padding: 30px 0;
      background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
      color: white;
      border-radius: 10px;
      margin-bottom: 30px;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    }
    
    .risk-header h1 {
      margin: 0;
      font-size: 28px;
      font-weight: 600;
    }
    
    .company-name {
      color: #3498db;
      font-weight: bold;
    }
    
    .risk-grid {
      display: grid;
      gap: 25px;
    }
    
    .risk-card {
      background: white;
      border-radius: 10px;
      padding: 25px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.08);
      border-left: 5px solid #e74c3c;
      transition: transform 0.2s ease;
    }
    
    .risk-card:hover {
      transform: translateY(-3px);
      box-shadow: 0 5px 15px rgba(0,0,0,0.1);
    }
    
    .risk-number {
      display: inline-block;
      background: #e74c3c;
      color: white;
      width: 35px;
      height: 35px;
      border-radius: 50%;
      text-align: center;
      line-height: 35px;
      font-weight: bold;
      margin-right: 15px;
      font-size: 18px;
    }
    
    .risk-title {
      display: inline;
      font-size: 22px;
      color: #2c3e50;
      margin: 0;
      vertical-align: middle;
    }
    
    .risk-section {
      margin-top: 20px;
    }
    
    .section-title {
      color: #3498db;
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
    }
    
    .section-title::before {
      content: "•";
      margin-right: 10px;
      color: #3498db;
      font-size: 24px;
    }
    
    .risk-description, .risk-impact {
      color: #555;
      line-height: 1.6;
      margin-bottom: 15px;
      padding-left: 20px;
    }
    
    .strategies-list {
      padding-left: 20px;
    }
    
    .strategy-item {
      margin-bottom: 10px;
      padding-left: 25px;
      position: relative;
      color: #555;
      line-height: 1.6;
    }
    
    .strategy-item::before {
      content: "+";
      position: absolute;
      left: 0;
      color: #27ae60;
      font-weight: bold;
      font-size: 18px;
    }
    
    .risk-stats {
      text-align: center;
      margin-top: 40px;
      padding: 20px;
      background: white;
      border-radius: 10px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.08);
    }
    
    .stats-title {
      color: #2c3e50;
      font-size: 20px;
      margin-bottom: 15px;
    }
    
    .risk-count {
      font-size: 48px;
      font-weight: bold;
      color: #e74c3c;
      margin: 0;
    }
    
    @media (max-width: 768px) {
      .risk-container {
        padding: 15px;
      }
      
      .risk-header {
        padding: 20px 0;
      }
      
      .risk-header h1 {
        font-size: 24px;
      }
      
      .risk-card {
        padding: 20px;
      }
      
      .risk-title {
        font-size: 20px;
      }
    }
  `;

    return `
    <div class="risk-container">
      <style>${styles}</style>
      
      <div class="risk-header">
        <h1>Risk Assessment for <span class="company-name">${data.company}</span></h1>
      </div>
      
      <div class="risk-grid">
        ${data.risks.map(risk => `
          <div class="risk-card">
            <div class="risk-header-section">
              <span class="risk-number">${risk.number}</span>
              <h2 class="risk-title">${risk.title}</h2>
            </div>
            
            <div class="risk-section">
              <div class="section-title">Risk Description</div>
              <div class="risk-description">${risk.description}</div>
            </div>
            
            <div class="risk-section">
              <div class="section-title">Potential Impact</div>
              <div class="risk-impact">${risk.impact}</div>
            </div>
            
            <div class="risk-section">
              <div class="section-title">Mitigation Strategies</div>
              <div class="strategies-list">
                ${risk.strategies.map(strategy => `
                  <div class="strategy-item">${strategy}</div>
                `).join('')}
              </div>
            </div>
          </div>
        `).join('')}
      </div>
      
      <div class="risk-stats">
        <div class="stats-title">Total Risks Identified</div>
        <div class="risk-count">${data.risks.length}</div>
      </div>
    </div>
  `;
  };

  // Usage: Directly call this to get HTML
  const formattedHTML = renderFormattedContent();
  console.log(formattedHTML); // Ye HTML aap directly frontend pe render kar sakte hain

  // Ya phir agar React component chahiye to:
  const RiskAssessmentComponent = () => {
    return <div dangerouslySetInnerHTML={{ __html: renderFormattedContent() }} />;
  };

  return (
    <div className="risk-assessment">
      {RiskAssessmentComponent()}
    </div>
  );
}

export default AnalysisForm;